"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var class_transformer_1 = require("class-transformer");
var ChariotResource_1 = require("./ChariotResource");
var api_1 = require("../api");
var Errors_1 = require("../../helpers/Errors");
var Equipment = /** @class */ (function (_super) {
    __extends(Equipment, _super);
    function Equipment(apiEquipment, chariot, points) {
        if (points === void 0) { points = []; }
        var _this = _super.call(this, apiEquipment, chariot) || this;
        _this.points = [];
        _this.pointsEmpty = false;
        _this.pointNames = {};
        _this.supports = {};
        _this._ = (0, class_transformer_1.plainToClass)(api_1.ApiEquipment, apiEquipment);
        _this.points = points;
        return _this;
    }
    Equipment.prototype.getDisplayName = function () {
        if (this._.display_name && this._.display_name.length > 0) {
            return this._.display_name;
        }
        return this._.name;
    };
    Equipment.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var body, apiEquipment, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 8, , 9]);
                        return [4 /*yield*/, this.chariot.verifyWriteAccess()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.validateApiResource()];
                    case 2:
                        _b.sent();
                        body = this._;
                        delete body.points;
                        apiEquipment = void 0;
                        if (!this._.id) return [3 /*break*/, 5];
                        _a = body;
                        return [4 /*yield*/, this.getPoints()];
                    case 3:
                        _a.points = (_b.sent()).map(function (_a) {
                            var _ = _a._;
                            return _;
                        });
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/atlas/equipment/".concat(this._.id),
                                method: "PATCH",
                                body: body
                            })];
                    case 4:
                        apiEquipment = _b.sent();
                        this.chariot.logger.log("Equipment successfully updated");
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.chariot.RestApi.request({
                            path: "/atlas/equipment",
                            method: "POST",
                            body: body
                        })];
                    case 6:
                        apiEquipment = _b.sent();
                        this.chariot.logger.log("Equipment successfully created");
                        _b.label = 7;
                    case 7:
                        this._ = (0, class_transformer_1.plainToClass)(api_1.ApiEquipment, __assign(__assign({}, this._), apiEquipment));
                        return [2 /*return*/, this];
                    case 8:
                        e_1 = _b.sent();
                        this.chariot.logger.catch(e_1, "Failed to save equipment");
                        throw e_1;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    Equipment.prototype.update = function (apiEquipment) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._ = (0, class_transformer_1.plainToClass)(api_1.ApiEquipment, __assign(__assign({}, this._), apiEquipment));
                        return [4 /*yield*/, this.save()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Equipment.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.chariot.verifyWriteAccess()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.chariot.RestApi.request({
                                path: "/atlas/equipment/".concat(this._.id),
                                method: "DELETE"
                            })];
                    case 2:
                        _a.sent();
                        this.chariot.Equipment.__removeFromCache(this);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.chariot.logger.catch(e_2, "Failed to save equipment");
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Equipment.prototype.getPoints = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve points for an equipment that does not exist. Try Equipment.save()");
                        }
                        if (this.points.length > 0 || this.pointsEmpty)
                            return [2 /*return*/, this.points];
                        if (!(this._.points && this._.points.length > 0)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, Promise.all(this._.points.map(function (point) { return _this.chariot.Point.build(__assign(__assign({}, point), { equipment_id: _this._.id, site_id: _this._.site_id })); }))];
                    case 1:
                        _a.points = _c.sent();
                        return [2 /*return*/, this.points];
                    case 2:
                        _b = this;
                        return [4 /*yield*/, this.chariot.Point.list({
                                params: {
                                    equipment_id: this._.id
                                }
                            })];
                    case 3:
                        _b.points = _c.sent();
                        this.pointsEmpty = this.points.length == 0;
                        return [2 /*return*/, this.points];
                }
            });
        });
    };
    Equipment.prototype.findPointByName = function (caseInsensitivePointName) {
        return __awaiter(this, void 0, void 0, function () {
            var points;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPoints()];
                    case 1:
                        points = _a.sent();
                        return [2 /*return*/, points.find(function (_a) {
                                var _ = _a._;
                                return _.name.toLowerCase() == caseInsensitivePointName.toLowerCase();
                            }) || null];
                }
            });
        });
    };
    Equipment.prototype.createPoint = function (apiPoint) {
        return __awaiter(this, void 0, void 0, function () {
            var point;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chariot.Point.build(__assign(__assign({}, apiPoint), { equipment_id: this._.id }))];
                    case 1:
                        point = _a.sent();
                        return [4 /*yield*/, point.save()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Equipment.prototype.getRuleEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var points, point_ids, ruleEvents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve rule events for an equipment that does not exist. Try Equipment.save()");
                        }
                        return [4 /*yield*/, this.getPoints()];
                    case 1:
                        points = _a.sent();
                        point_ids = points
                            .map(function (_a) {
                            var _ = _a._;
                            return _.id;
                        })
                            .filter(function (id) { return id; });
                        return [4 /*yield*/, this.chariot.RuleEvent.list({
                                filters: {
                                    point_ids: point_ids
                                }
                            })];
                    case 2:
                        ruleEvents = _a.sent();
                        return [2 /*return*/, ruleEvents];
                }
            });
        });
    };
    Equipment.prototype.getOnlineStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var points, criticalPoints, statuses;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._.id) {
                            throw new Errors_1.OrderOfOperationsError("Attempted to retrieve status for an equipment that does not exist. Try Equipment.save()");
                        }
                        return [4 /*yield*/, this.getPoints()];
                    case 1:
                        points = _a.sent();
                        criticalPoints = points.filter(function (_a) {
                            var _ = _a._;
                            return _.critical;
                        });
                        return [4 /*yield*/, Promise.all(criticalPoints.map(function (point) { return point.getStatus(); }))];
                    case 2:
                        statuses = _a.sent();
                        return [2 /*return*/, statuses.every(function (status) { return !status || status == "ok"; })];
                }
            });
        });
    };
    return Equipment;
}(ChariotResource_1.default));
exports.default = Equipment;
